
/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  CompanyTypeResource,
  EligibleTaxesResource,
} from '../models';
import {
    CompanyTypeResourceFromJSON,
    CompanyTypeResourceToJSON,
    EligibleTaxesResourceFromJSON,
    EligibleTaxesResourceToJSON,
} from '../models';

export interface FindOneRequest {
    id: string;
}

export interface GetEligibleTaxesRequest {
    companyTypeId: string;
    country?: string;
    zipcode?: string;
}

export interface LegalsForCountryRequest {
    country: string;
    companyId: string;
}

/**
 * 
 */
export class CompanyTypesApi extends runtime.BaseAPI {

    /**
          */
    async findOneRaw(requestParameters: FindOneRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<CompanyTypeResource>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling findOne().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<CompanyTypeResource>({
            path: `/compliance/api/company-types/type/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=CompanyTypeResourceFromJSON(response._data); }
        return response;
    }

    /**
          */
    async findOne(requestParameters: FindOneRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<CompanyTypeResource> {
        const response = await this.findOneRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
          */
    async getEligibleTaxesRaw(requestParameters: GetEligibleTaxesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<EligibleTaxesResource>>> {
        if (requestParameters['companyTypeId'] == null) {
            throw new runtime.RequiredError(
                'companyTypeId',
                'Required parameter "companyTypeId" was null or undefined when calling getEligibleTaxes().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['companyTypeId'] != null) {
            queryParameters['companyTypeId'] = requestParameters['companyTypeId'];
        }

        if (requestParameters['country'] != null) {
            queryParameters['country'] = requestParameters['country'];
        }

        if (requestParameters['zipcode'] != null) {
            queryParameters['zipcode'] = requestParameters['zipcode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<EligibleTaxesResource>>({
            path: `/compliance/api/eligible-taxes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(EligibleTaxesResourceFromJSON);
        return response;
    }

    /**
          */
    async getEligibleTaxes(requestParameters: GetEligibleTaxesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<EligibleTaxesResource>> {
        const response = await this.getEligibleTaxesRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
          */
    async legalsForCountryRaw(requestParameters: LegalsForCountryRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<CompanyTypeResource>>> {
        if (requestParameters['country'] == null) {
            throw new runtime.RequiredError(
                'country',
                'Required parameter "country" was null or undefined when calling legalsForCountry().'
            );
        }

        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling legalsForCountry().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['companyId'] != null) {
            queryParameters['companyId'] = requestParameters['companyId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<CompanyTypeResource>>({
            path: `/compliance/api/company-types/{country}`.replace(`{${"country"}}`, encodeURIComponent(String(requestParameters['country']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(CompanyTypeResourceFromJSON);
        return response;
    }

    /**
          */
    async legalsForCountry(requestParameters: LegalsForCountryRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<CompanyTypeResource>> {
        const response = await this.legalsForCountryRaw(requestParameters, initOverrides);
        return response._data;
    }

}
